/**
 * MesaDiretora view component.
 * @module components/Views/MesaDiretoraView
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@plone/components';
import ProfilesTemplate from '../../Blocks/Listing/ProfilesTemplate';
import { TableRow, TableCell, TableBody, Table } from 'semantic-ui-react';

const Details = ({ content }) => {
  return (
    <Container className={'details'}>
      <Table className={'details'}>
        <TableBody>
          <TableRow>
            <TableCell className={'label'}>Legislatura</TableCell>
            <TableCell className={'value'}>{content.legislatura}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Início</TableCell>
            <TableCell className={'value'}>
              {content.start ? content.start : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Término</TableCell>
            <TableCell className={'value'}>
              {content.end ? content.end : '-'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Container>
  );
};

/**
 * MesaDiretora view component class.
 * @function MesaDiretoraView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const MesaDiretoraView = (props) => {
  const { content } = props;
  const { description } = content;

  return (
    <Container narrow id="page-document" className="view-wrapper vereador-view">
      <h1 className="documentFirstHeading">{description}</h1>
      <Details content={content} />
      <div id={'vereadores'} className={'block listing profiles'}>
        <h2 className={'headline'}>Composição</h2>
        <ProfilesTemplate items={content.items} />
      </div>
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
MesaDiretoraView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default MesaDiretoraView;
